import { useCallback, useState } from "react";
import { neon } from "@/integrations/neon";
import { logSecurityEvent } from "@/utils/security";

interface CreateScriptPayload {
  movieName: string;
  customMessage: string;
  scriptUrl: string;
  scriptUrlTh: string;
  passwordProtected: boolean;
}

interface CreateScriptResult {
  script: {
    id: string;
  };
}

interface UseCreateScriptReturn {
  isCreating: boolean;
  createScript: (payload: CreateScriptPayload) => Promise<CreateScriptResult>;
}

export const useCreateScript = (): UseCreateScriptReturn => {
  const [isCreating, setIsCreating] = useState(false);

  const createScript = useCallback(async (payload: CreateScriptPayload) => {
    setIsCreating(true);

    try {
      const result = await neon.api.scripts.create(payload);

      await logSecurityEvent("script_created", {
        script_id: result.script.id,
        password_protected: payload.passwordProtected,
        forms_count: 0,
      });

      return result satisfies CreateScriptResult;
    } finally {
      setIsCreating(false);
    }
  }, []);

  return {
    isCreating,
    createScript,
  };
};
